import axios from 'axios';

// 记录接口异常时间，防止循环请求
const errorMap = new Map();
const RETRY_DELAY = 1000; // 异常后1秒内禁止再次请求

// 创建axios实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8085',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 检查该接口是否处于冷却期
    const requestKey = `${config.method}-${config.url}`;
    const lastErrorTime = errorMap.get(requestKey);
    
    if (lastErrorTime && Date.now() - lastErrorTime < RETRY_DELAY) {
      return Promise.reject(new Error('请求过于频繁，系统已自动拦截'));
    }
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 请求成功，清除错误记录
    if (response.config) {
      const requestKey = `${response.config.method}-${response.config.url}`;
      errorMap.delete(requestKey);
    }
    return response;
  },
  error => {
    // 记录接口报错时间
    if (error.config) {
      const requestKey = `${error.config.method}-${error.config.url}`;
      errorMap.set(requestKey, Date.now());
    }
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

// 获取商品列表
export const getProductList = (params) => {
  return api.get('/api/jd/product/list', { params });
};

// 搜索/转链商品
export const searchProduct = (data) => {
  return api.post('/api/jd/product/search', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default api;

